import React from 'react';
import { browserHistory } from 'react-router';

class screenComponent extends React.Component {
    constructor(props) {
		super(props);

        this.state = {
            loaded: false
        }
	}

    componentDidMount() {
        setTimeout( () => {
            this.setState({
                loaded: true
            })
        }, 1000);
    }

    componentDidUpdate() {
        if (this.props.state.user.isLoggedIn) {
            browserHistory.push('/onlinemarkets');
        }
    }

    render() {
        return (
            <div className={'collage_holder '+(this.state.loaded && 'loaded')}>
                <div className='collage_wrapper'>
                    <div className='collage_text' />
                    <div className='collage_title' />
                </div>
            </div>
        )
    }
}

export default screenComponent;



// WEBPACK FOOTER //
// ./source/screens/Home.js